import { AssetChubbBookingBannerInterface } from '@app/entities/asset-chubb-booking-banner';
import { AssetChubbBookingBannerBase } from './asset-chubb-booking-banner.base';

export const AssetChubbBookingBanner: AssetChubbBookingBannerInterface = {
  ...AssetChubbBookingBannerBase,
  ENABLED_FREE_ASSISTANCE: {
    TYPES: [],
    IS_NATIONAL_TRIP: false,
    IS_INTERNATIONAL_TRIP: false,
    ONLY_PRIME_USER: false,
  },
  ENABLED_ASSISTANCE_INTERFACE: [],
  ENABLED_ASSISTANCE_INTERFACE_DETAIL: [],
  SECTION_TITLE: 'Seguro de viajante',
  TITLE: 'Viagem protegida',
  SUB_TITLE: 'Presente de Rappi',
  COUNTER_BANNER_WITH_SINGLE: 'Total para 1 viajante',
  COUNTER_BANNER_WITH_PLURAL: 'Total para {{travelers}} viajantes',
  DAYS: 'dias',
  DAY: 'dia',
  NIGHT: 'noite',
  NIGHTS: 'noites',
  NATIONAL_COPY_OPTIONS: [
    'Cobertura por Acidentes Pessoais - Até USD 4.000',
    'Cobertura por Gastos Médicos e Odontológicos - Até USD 500',
    'Cobertura por atraso de Viagem - Até USD 100',
    'Indenização em caso de atraso ou perda de equipagem - Até USD 140 '
  ],
  INTERNATIONAL_COPY_OPTIONS: [
    'Cobertura por Acidentes Pessoais - Até USD 5.000',
    'Cobertura por Gastos Médicos e Odontológicos - Até USD 3.000',
    'Cobertura por atraso de Viagem  - Até USD 200',
    'Indenização em caso de atraso ou perda de equipagem - Até USD 200'
  ],
  LATERAL_BANNER: null,
  ASSISTANCE: {
    TITLE: 'Seguro viagem',
    SUB_TITLE: 'Gostaria de viajar protegido?',
    SUB_TITLE_CROSS_SELLING: 'Deseja adicionar assistência em viagem?',
    CHECKBOX_MESSAGE_PRICE: 'Sim! quero viajar protegido por {{assistance_price}}.',
    CHECKBOX_MESSAGE_TERMS: 'Declaro que li e estou de acordo com os termos e condições',
    CHECKBOX_MESSAGE_DISCLAIMER: 'Aceito os termos e condições do seguro clicando no botão "Ir para pagar".' +
      ' Se você não quiser comprá-lo, você pode desmarcar esta opção.',
    YES_ACTION_BOOK: 'Sim! eu quero adicioná-lo',
    NO_ACTION_BOOK: 'Não, obrigado',
    FORCED_YES: 'Sim, viaje protegido!',
    FORCED_NO: 'Viajar sem seguro',
    VALUES_SWITCH_LABEL: 'Valores',
    TERMS_SWITCH_LABEL: 'Termos',
    INSURED_LIMIT_LABEL: 'Limite segurado',
    INCLUDES_BANNER_MESSAGE: 'Inclui',
    FOOTER_BANNER_MESSAGE: 'Detalhes de cobertura e condições',
    TERMS_TITLE: 'TERMOS E CONDIÇÕES DO SEGURO DE VIAGEM CHUBB RAPPI TRAVEL',
    INSURED_SUM_VARIES_AGE: 'O capital segurado pode alterar de acordo com a idade do segurado, para mais informações ' + 
    'consulte os termos e condiçõe',
    ASSISTANCE_TERMS: [
      {
        TITLE: `Atenção: O Seguro Viagem não é seguro saúde! Leia atentamente as condições contratuais, 
        observando seus direitos e obrigações, bem como o limite do capital segurado contratado para cada cobertura.`,
        PARAGRAPHS: []
      },
      {
        TITLE: 'INFORMAÇÕES IMPORTANTES',
        PARAGRAPHS: [
          `<strong>Regresso Antecipado</strong> – Se o segurado regressar antecipadamente da viagem segurada, 
          fica cancelado o seguro a partir da sua chegada ao local de origem da viagem ou de seu domicílio, 
          conforme o caso, estando cobertos eventuais sinistros ocorridos antes do cancelamento. 
          Não se aplicará, neste caso, nenhuma forma de restituição do prêmio pago.`,
          `<strong>Direito de arrependimento</strong> – O segurado poderá desistir do seguro contratado 
          desde que antes da viagem e no prazo de 7 (sete) dias corridos a contar da emissão deste bilhete de seguro.  
          Neste caso, o prêmio de seguro eventualmente pago será devolvido pelo mesmo meio e forma de efetivação 
          de seu pagamento na contratação, sem prejuízo de outros meios ou formas disponibilizadas. Para exercer 
          esse direito, o segurado deverá comunicar sua desistência no mesmo meio utilizado na contratação do seguro. 
          Na eventual impossibilidade desse canal efetuar o cancelamento, o segurado poderá entrar com contato com a 
          Central de Atendimento Chubb Seguros no telefone 0800 000 0436 para maiores esclarecimentos.`,
          `<strong>Período de cobertura deste seguro</strong> – Respeitado a vigência da apólice, a vigência se dará durante 
          a viagem de ida e volta do Segurado, entre o ponto de partida e o destino, conforme indicação da passagem, 
          incluindo a permanência no destino, exceto para a cobertura de Cancelamento que inicia às 24hs da data de 
          pagamento do prêmio e termina na data de embarque (início da viagem). Este seguro é por prazo determinado, 
          e não será renovado.`,
          `<strong>Capital Segurado da cobertura de Despesas Médicas e/ou Hospitalares</strong> – Os limites de capital segurado 
          para a cobertura de Despesas Médicas e/ou Hospitalares devem ser respeitados para todos os planos de Seguro 
          Viagem, considerando que para segurados com idade de 65 a 75 anos haverá redução de 50% no capital segurado 
          e para segurados com idade de 76 a 85 anos haverá redução de 75% no valor do limite segurado para a 
          cobertura de Despesas Médicas e/ou Hospitalares. Caso o destino da viagem segurada seja a Europa, o 
          limite do capital segurado da cobertura de Despesas Médicas e/ou Hospitalares será calculada em Euros 
          em cumprimento ao Tratado de Schengen.`,
          `<strong>Antecedência máxima de compra</strong> – Os bilhetes podem ser comercializados com até 365 
          (trezentos e sessenta e cinco) dias de antecedência do início da viagem.`,
          '<strong>Período mínimo de viagem (dias consecutivos):</strong> 1 (um) dia.',
          '<strong>Período máximo de viagem (dias consecutivos):</strong> 90 (noventa) dias.',
          '<strong>Idade máxima do segurado:</strong> 85 anos, 11 meses e 29 dias no momento da compra do bilhete.',
        ]
      },
      {
        TITLE: 'INFORMAÇÕES SOBRE VALORES DO SEGURO',
        PARAGRAPHS: [
          `A remuneração do Representante de Seguros, a título de pró-labore, está contida 
          no valor total do prêmio do Seguro Viagem e corresponde a 40% do prêmio líquido de 
          IOF, equivalente a R$1,68. <strong>Importante:</strong> Para os valores em moeda estrangeira, o prêmio 
          correspondente será pago em moeda corrente nacional, convertido pela taxa cambial da 
          data de contratação do Seguro Viagem, com base nas regras específicas do BACEN e CMN`,
          `Em atendimento à Lei 12.741/12 informamos que incidem as alíquotas de 0,65% de PIS/Pasep 
          e de 4% de COFINS sobre os prêmios de seguros, deduzidos do estabelecido em legislação 
          específica. Prêmio de seguro inclui 0,38% de IOF.`
        ]
      },
      {
        TITLE: 'TRATAMENTO DE DADOS PESSOAIS',
        PARAGRAPHS: [
          `Todos os dados pessoais coletados pela Chubb Seguros do Brasil S.A. 
          serão tratados de acordo com a legislação aplicável em vigor. 
          Processamos seus dados para lhe vendermos este seguro ou para atividades 
          relacionadas ao seguro. Você pode buscar mais informações sobre finalidade e 
          direitos dos titulares na política de privacidade disponível no site 
          www.chubb.com/br-pt/footer/politica-de-privacidade-da-chubb.html `
        ]
      },
      {
        TITLE: 'CANAIS DE ATENDIMENTO',
        PARAGRAPHS: [
          `<strong>Central de Atendimento ao Consumidor (SAC) Chubb Seguros:</strong> Para esclarecimento de 
          dúvidas, reclamações ou solicitações ligue 0800 000 0436, atendimento 24h, 7 dias por semana. 
          Atendimento para deficientes auditivos ou de fala: 0800 722 5112, atendimento 24h, 7 dias por semana.`,
          `<strong>Ouvidoria:</strong> Registrou uma reclamação no SAC e não houve solução satisfatória? 
          Contate-nos no e-mail ouvidoria@chubb.com  ou ligue <strong>0800 722 5059,</strong> atendimento de segunda 
          a sexta-feira das 08h às 18h, <strong>exceto feriados.</strong> Atendimento para deficientes auditivos ou de 
          fala: 0800 724 5084, atendimento de segunda a sexta, das 08h às 18h, exceto feriados. Caixa 
          Postal: 310, Agência 72300019, CEP: 01031-970.`,
          `<strong>Disque fraude: 0800 770 8135.</strong> Se você conhece ou suspeita de alguma fraude 
          aos seguros contratados junto à Chubb, denuncie. O canal é gratuito e sigiloso, dedicado 
          a receber ligações de segunda a sexta, das 08h às 18h, <strong>exceto feriados.</strong>`,
        ]
      },
      {
        TITLE: 'INFORMAÇÕES GERAIS',
        PARAGRAPHS: [
          `As condições contratuais deste produto protocolizadas pela Chubb Seguros Brasil S.A. 
          junto à SUSEP poderão ser consultadas no endereço eletrônico www.susep.gov.br por meio 
          do número do processo SUSEP 15414.900439/2015-34 (Seguro Viagem Individual). As condições 
          contratuais também poderão ser consultadas por meio do portal da Chubb: 
          https://meusegurochubb.com.br/travel/individual. Para informações sobre as coberturas 
          referentes a COVID-19 consulte as Condições Particulares do produto no link  
          https://meusegurochubb.com.br/travel/rappitravelcondparticular.`,
          `SUSEP – Superintendência de Seguros Privados – Autarquia Federal responsável pela 
          fiscalização, normatização e controle dos mercados de seguro, previdência complementar 
          aberta, capitalização, resseguro e corretagem de seguros. Atendimento Exclusivo aos 
          Consumidores: 0800 021 8484 (somente ligações oriundas de telefones fixos) ou pelo 
          WhatsApp (21) 97684-7806, de segunda a sexta, exceto feriados, das 9h30 às 17h. 
          Plataforma digital para registro de reclamações de mercados supervisionados pela 
          SUSEP: www.consumidor.gov.br.`,
          `Este seguro é garantido pela <strong>CHUBB Seguros Brasil S.A.</strong>, CNPJ 03.502.099/0001-18, 
          registro SUSEP 0651-3.`,
          `Representante de Seguros: <strong>Rappi Agência de Viagens e Turismo LTDA.</strong>, 
          CNPJ 35.506.356/0001-86.`,
        ]
      }
    ]
  }
};
